


















import {Component, Vue} from 'vue-property-decorator';
import {IOrganization} from '@/models/IOrganization';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component
export default class OrganizationSelect extends Vue {
  loading: boolean = true;
  organization: IOrganization | null = null;

  protected created() {
    this.loadData();
  }

  onChange() {
    ModuleOrganization.setOrganizationId(this.organization!.id);
  }

  get listOrganizations() {
    return ModuleOrganization.organizations;
  }

  async loadData() {
    try {
      this.loading = true;
      await ModuleOrganization.getListOrganization();
      this.organization = this.listOrganizations[0];
      ModuleOrganization.setOrganizationId(this.organization!.id);
    } finally {
      this.loading = false;
    }
  }
}
